
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upload-landing",
      function () {
        return require("private-next-pages/upload-landing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upload-landing"])
      });
    }
  